export const INVITATION_ACCEPTANCE_SESSION_KEY = 'graftcode:invitation-accepted'
